import React from 'react'
import PropTypes from 'prop-types'
import { Switch, Route } from "react-router-dom"
import Organism from '../pages/species/Organism'
import Search from '../pages/search/Search'
import Tool from '../pages/tools/Tool'
import Genomics from '../pages/genomics/Genomics'
import Variations from '../pages/variations/Variations'
import Populations from '../pages/populations/Populations'
import Genetics from '../pages/genetics/Genetics'
import Feature from '../pages/feature/Feature'
import NotExists from '../pages/feature/NotExists'
import Aboutus from '../pages/help/Aboutus'
import News from '../pages/help/News'
import Tutorial from '../pages/help/Tutorial'
import Datasource from '../pages/help/Datasource'
import SL5 from '../pages/help/SL5'
import User from '../pages/user/User'
import Success from '../pages/Success'
import NotAllowed from '../pages/NotAllowed'
import NotFound from '../pages/NotFound'

class MainContent extends React.Component {
    render() {
        return (
            <Switch>
                <Route path="/species/:organism">
                    <Organism />
                </Route>
                <Route path="/search/:type">
                    <Search />
                </Route>
                <Route path="/tool/:tool">
                    <Tool />
                </Route>
                <Route path="/genomics">
                    <Genomics />
                </Route>
                <Route path="/variations">
                    <Variations />
                </Route>
                <Route path="/genetics">
                    <Genetics />
                </Route>
                <Route path="/populations">
                    <Populations />
                </Route>
                <Route exact path="/feature/notExists">
                    <NotExists />
                </Route>
                <Route path="/feature/:feature_id">
                    <Feature setPathSnippetsState={this.props.setPathSnippetsState} />
                </Route>
                <Route exact path="/about">
                    <Aboutus />
                </Route>
                 <Route exact path="/news">
                    <News />
                </Route>
                <Route exact path="/tutorial">
                    <Tutorial />
                </Route>
                <Route exact path="/help/sl5.0">
                    <SL5 />
                </Route>
                <Route exact path="/datasource/:id?">
                    <Datasource />
                </Route>
                <Route path="/user/:action">
                    <User setUserState={this.props.setUserState} setPathSnippetsState={this.props.setPathSnippetsState} />
                </Route>
                <Route exact path="/success/:action">
                    <Success setPathSnippetsState={this.props.setPathSnippetsState} />
                </Route>
                <Route exact path="/notAllowed">
                    <NotAllowed setPathSnippetsState={this.props.setPathSnippetsState} />
                </Route>
                <Route component={NotFound} />
            </Switch>
        )
    }
}

MainContent.propTypes = {
    setUserState: PropTypes.func,
    setPathSnippetsState: PropTypes.func
}

export default MainContent